import React, { Children } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon } from 'lucide-react';
import { formatCurrencyAmount } from '../../../theme/tokens';
export function ReservationDetail() {
  const {
    t
  } = useTranslation('rooms');
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 May 2026',
      checkOut: '11 May 2026',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.mv',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Maldivan escape early and enjoy the added luxury of a complimentary round-trip seaplane transfer from Malé to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: formatCurrencyAmount(1.0, {
        fractionDigits: 2
      }),
      serviceCharge: formatCurrencyAmount(0.1, {
        fractionDigits: 2
      })
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-9298">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-9299">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-9300">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-9301" />
          <span data-id="element-9302">{t('pages.ReservationDetail.reservation_details')}</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-9303">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-9304">
          <div className="flex justify-between items-center" data-id="element-9305">
            <h2 className="text-xl font-bold" data-id="element-9306">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-9307">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-9308">
                {t('pages.ReservationDetail.confirmed')}
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-9309">
                {t('pages.ReservationDetail.resend_confirmation_email')}
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-9310">
          <div className="p-6 border-r border-gray-200" data-id="element-9311">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-9312">
              {t('pages.ReservationDetail.date')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-9313">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-9314">
              {reservation.date.nights} {t('pages.ReservationDetail.nights')}
            </p>
          </div>
          <div className="p-6" data-id="element-9315">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-9316">
              {t('pages.ReservationDetail.guests_rooms')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-9317">
              {reservation.guests.adults} {t('pages.ReservationDetail.adults')}{' '}
              {reservation.guests.children}{' '}
              {t('pages.ReservationDetail.children')}{' '}
              {reservation.guests.infants}{' '}
              {t('pages.ReservationDetail.infants')}
            </p>
            <p className="text-sm text-gray-500" data-id="element-9318">
              {reservation.guests.rooms} {t('pages.ReservationDetail.room')}
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9319">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9320">
            {t('pages.ReservationDetail.booking_information')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9321">
            <div data-id="element-9322">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9323">
                {t('pages.ReservationDetail.booking_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9324">{reservation.booking.id}</p>
            </div>
            <div data-id="element-9325">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9326">
                {t('pages.ReservationDetail.transaction_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9327">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9328">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9329">
            {t('pages.PropertyInformation.hotel')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9330">
            <div data-id="element-9331">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9332">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9333">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-9334">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9335">
                {t('pages.ReservationDetail.hotel_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9336">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9337">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9338">
            {t('pages.Rates.room_type')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-9339">
            <div data-id="element-9340">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9341">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9342">{reservation.room.name}</p>
            </div>
            <div data-id="element-9343">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9344">
                {t('pages.ReservationDetail.view')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9345">{reservation.room.view}</p>
            </div>
            <div data-id="element-9346">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9347">
                {t('pages.ReservationDetail.category')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9348">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-9349">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9350">
            {t('pages.ReservationDetail.guest_information')}
          </h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-9351">
            <h4 className="text-base font-medium mb-4" data-id="element-9352">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9353">
              <div data-id="element-9354">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9355">
                  {t('pages.ReservationDetail.email')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9356">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-9357">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9358">
                  {t('pages.PropertyInformation.phone_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9359">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-9360">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9361">
                  {t('pages.ReservationDetail.passport_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9362">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-9363">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9364">
                  {t('pages.ReservationDetail.date_of_birth')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9365">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-9366">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9367">
                  {t('pages.ReservationDetail.nationality')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9368">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-9369">
                <p className="text-sm text-gray-500 mb-1" data-id="element-9370">
                  {t('pages.ReservationDetail.special_requests')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-9371">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-9372">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9373">
            {t('pages.ReservationDetail.rate_details')}
          </h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-9374">
            <div data-id="element-9375">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9376">
                {t('pages.ReservationDetail.rate_name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9377">{reservation.rate.name}</p>
            </div>
            <div data-id="element-9378">
              <p className="text-sm text-gray-500 mb-1" data-id="element-9379">
                {t('components.AddRoomForm.description')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9380">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-9381">
          <h3 className="text-sm font-semibold mb-4" data-id="element-9382">
            {t('pages.ReservationDetail.price_breakdown')}
          </h3>
          <div className="space-y-3" data-id="element-9383">
            <div className="flex justify-between" data-id="element-9384">
              <p className="text-sm text-gray-500" data-id="element-9385">
                {t('pages.ReservationDetail.subtotal')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9386">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-9387">
              <p className="text-sm text-gray-500" data-id="element-9388">
                {t('pages.ReservationDetail.service_charge')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-9389">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-9390">
              <p className="text-sm font-medium" data-id="element-9391">
                {t('pages.ReservationDetail.total')}
              </p>
              <p className="text-sm font-bold" data-id="element-9392">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}